
<div class="directionLtr" id="chartdiv" [style.width.%]="100" [style.height.px]="330"></div>